import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { AreaChartSkeleton } from './components/AreaChartSkeleton';
import { EmptyLineOrBarChart } from './EmptyLineOrBarChart';
import { Line } from 'react-chartjs-2';

type AreaChartWithUserSelectSuspense = {
  accountRef?: string | null;
  xAxisLabels?: string[];
  children: (accountRef: string) => React.ReactNode;
};
export const AreaChartWithUserSelectAndSuspenseContainer = ({
  accountRef,
  xAxisLabels,
  children,
}: AreaChartWithUserSelectSuspense) => {
  const { t } = useTranslation();

  return (
    <Suspense fallback={<AreaChartSkeleton />}>
      {accountRef ? (
        children(accountRef)
      ) : (
        <EmptyLineOrBarChart
          as={Line}
          emptyChartText={t('dashboard.placeholders.selectAccount')}
          xAxisLabels={xAxisLabels}
        />
      )}
    </Suspense>
  );
};
